<div
  class="min-h-screen flex items-center justify-center bg-surface-v2 relative ">
  <div
    class="absolute inset-0 bg-radial-[at_50%_100%] from-[#1A2366] from-0% to-70% to-transparent top-[85%] w-3/4 left-1/2 -translate-x-1/2 lg:block hidden"></div>

  <div
    class="absolute inset-0 bg-gradient-to-t from-[#1A2366] from-0% to-70% to-transparent top-[85%] w-full left-1/2 -translate-x-1/2 lg:hidden"></div>

    <div class="overflow-y-auto">
  <ng-content></ng-content>
  </div>
</div>
